import React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './ModernSelect.css';

const ModernSelect = ({ value, onChange, options, label, className = '' }) => {
  return (
    <div className={`modern-select-container ${className}`}>
      {label && <label className="modern-select-label">{label}</label>}
      <div className="modern-select-wrapper">
        <select
          value={value}
          onChange={onChange}
          className="modern-select"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <FaChevronDown className="select-arrow" />
      </div>
    </div>
  );
};

export default ModernSelect;

